import { render } from "./Genres.vue?vue&type=template&id=ba83f920"
import script from "./Genres.vue?vue&type=script&lang=js"
export * from "./Genres.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__